module.exports = __webpack_public_path__ + "static/media/Barmag 2c.8c2f21aa.jpg";